import { getPropsToDisableInSearch } from './getPropsToDisableInSearch';
/**
 * Gets the description to be printed in the banner.
 *
 * @param targetUser The contact merge target user.
 */
export function getBannerDescription(targetUser) {
    if (!targetUser) {
        return '';
    }
    const disabledProps = getPropsToDisableInSearch(targetUser);
    if (disabledProps.includes('email') &&
        disabledProps.includes('phone_number')) {
        return 'You can only select a contact that has no existing phone number or email';
    }
    if (disabledProps.includes('email')) {
        return 'You can only select a contact that has no existing email';
    }
    if (disabledProps.includes('phone_number')) {
        return 'You can only select a contact that has no existing phone number';
    }
    return '';
}
